module.exports = new __parcel__URL__("machine_item_info_divider_long.c3dfc163.png").toString();